module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "scroll-marker",
    class: {
      'is-standby': _vm.standby, 'is-dark': _vm.darkMode
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "scroll-marker__inner"
  }, [_c('div', {
    staticClass: "label"
  }, [_c('span', {
    ref: "label",
    staticClass: "label__content"
  }, [_vm._v(_vm._s(_vm.label))])]), _c('div', {
    staticClass: "graphic"
  }, [_c('div', {
    ref: "bar",
    staticClass: "graphic-bar"
  }, [_c('div', {
    ref: "barPoint",
    staticClass: "graphic-bar__point"
  })]), _c('div', {
    ref: "arrow",
    staticClass: "graphic-arrow"
  }, [_c('div', {
    ref: "arrowTip",
    staticClass: "graphic-arrow__tip"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c739e8ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scroll-marker.vue
// module id = 502
// module chunks = 0